import React, {Component} from 'react'
import Grid from "../../../Utils/Grid";
import {TableHeaderColumn} from "react-bootstrap-table";
import {standardActions} from "../../../Utils/Grid/StandardActions";
import Card from "Utils/Cards/Card"
import Header from "Utils/Grid/Header";

export default class RolesList extends Component{
    componentWillMount() {
        const { listar, page } = this.props;
        listar(page);
    }

    render() {
        const { listar: onPageChange, onSortChange, eliminar } = this.props;
        const { data, loader, page } = this.props;
        return(
            <div className="mb-4 col-12">
                <Card
                    icon="configuraciones_activo"
                    titulo="ROLES"
                    subtitulo="Del sistema">
                    <Header to="rol/crear" textBtn="CREAR ROL" {...this.props} />
                    <Grid hover striped data={data} loading={loader} page={page} onPageChange={onPageChange}>
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width='20%'
                            dataFormat={standardActions({ editar: "rol", eliminar})}
                        />
                        <TableHeaderColumn
                            isKey
                            dataField="nombre_rol"
                            dataSort
                            width='20%'
                        >
                            ROL
                        </TableHeaderColumn>
                        <TableHeaderColumn width='50%'/>
                    </Grid>
                </Card>
            </div>
        )
    }
}
